import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {AppConfig} from '../../app.config';
import { AuthService } from "@auth0/auth0-angular";

@Injectable()
export class SharedService {
  constructor(
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private router: Router,
    private authService: AuthService
  ) {
  }

  // Set and Get ROLES...
  storeRole(role, rememberMe) {
    if (rememberMe) {
      this.$localStorage.store('role', role);
    } else {
      this.$sessionStorage.store('role', role);
    }
  }

  getRole() {
    return this.$localStorage.retrieve('role') || this.$sessionStorage.retrieve('role');
  }

  getAccessToken() {
    return this.$localStorage.retrieve('access_token');
  }

  getIdToken() {
    return this.$localStorage.retrieve('id_token');
  }

  getUserName() {
    return this.$localStorage.retrieve('userName');
  }

  getUserId() {
    return this.$localStorage.retrieve('userId');
  }

  getObject(objectKey: string) {
    return JSON.parse(localStorage.getItem(objectKey));
  }

  setUserRole(role: string) {
    this.$localStorage.store('role', role);
  }

  setAccessToken(token: string) {
    this.$localStorage.store('access_token', token);
  }

  setIdToken(token: string) {
    this.$localStorage.store('id_token', token);
  }

  setUserId(userId: string) {
    this.$localStorage.store('userId', userId);
  }

  setObject(objectKey: string, objectValue: any) {
    localStorage.setItem(objectKey, typeof objectValue === 'object' ? JSON.stringify(objectValue) : objectValue);
  }

  setUserName(username: string) {
    this.$localStorage.store('userName', username);
  }

  isLoggedIn() {
    return !!this.getIdToken();
  }

  // Logout...
  logout() {
    // Token...
    
    // Redirect User to Login...
    this.router.navigate([AppConfig._LOGIN]).then(() => {
      this.$localStorage.clear();
      this.$sessionStorage.clear();
      this.storeRole(null, false);
      this.setCustomerId(null);
      this.setAccessToken(null);
      this.setIdToken(null);
      this.setObject(null, null);
      this.setUserId(null);
      this.setUserName(null);
      this.setUserRole(null);

    this.authService.ngOnDestroy();
      window.location.reload();
    });
  }

  setCustomerId(customerId: string) {
    this.$localStorage.store('customerId', customerId);
  }

  getCustomerId() {
    return this.$localStorage.retrieve('customerId');
  }
}
